var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew215({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.01,
    y: 1.01,
    width: 13.99,
    height: 13.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.26,4.06a9.76,9.76,0,0,1,1.91-.17,3.35,3.35,0,0,1,2.22.59,1.72,1.72,0,0,1,.67,1.43A1.92,1.92,0,0,1,5.69,7.68v0a2.07,2.07,0,0,1,1.67,2,2.16,2.16,0,0,1-.69,1.62,4,4,0,0,1-2.79.76A11.75,11.75,0,0,1,2.26,12Zm1,3.31h1C5.35,7.37,6,6.79,6,6,6,5.07,5.28,4.7,4.23,4.7a4.33,4.33,0,0,0-.93.07Zm0,3.87a5.2,5.2,0,0,0,.88,0c1.08,0,2.07-.39,2.07-1.57S5.31,8.16,4.17,8.16H3.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.76,4.05a11.55,11.55,0,0,1,2-.16A3.31,3.31,0,0,1,13,4.56a2.18,2.18,0,0,1,.71,1.69A2.4,2.4,0,0,1,13.12,8a3.34,3.34,0,0,1-2.47.89,3.56,3.56,0,0,1-.84-.07V12H8.76ZM9.81,8a3.44,3.44,0,0,0,.86.08c1.26,0,2-.61,2-1.73s-.76-1.58-1.91-1.58a4.93,4.93,0,0,0-1,.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew215);
export default __webpack_public_path__ + "static/media/Symbolpack_New_215.ea2883098182f3011e7d6cc5a2f1f796.svg";
export { ForwardRef as ReactComponent };